// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"b7e95fc3","659":"b7e95fc3","822":"b7e95fc3"}[chunkId] + ".chunk.css";
};